const languagemenu = (triggerSelector) => {
    const trigger = document.querySelector(triggerSelector);

    if (!trigger) {
        return
    }

    trigger.addEventListener('click', () => {
        trigger.classList.toggle("show");
    });

    document.addEventListener('click', (e) => {
        const globalClick = e.target.closest(triggerSelector);
        if (!globalClick) {
            trigger.classList.remove('show');
        }
    });
};

export {languagemenu}
